

let _ = require('../_.js');
let $ = jQuery;

let sealed_bid_modal_ui_init = false;

let property = null;
let items_active = null;
let items_all = null;
let item_ids = null;

let $modal = null;
let $form_items_container = null

let serialized_bids = {};

let step_number = 1;
let upload_key = null;
let file_name = null;

let _auto_close_interval = null;
let _auto_close_end_ms = null;

function _auto_close_tick() {
    if (!_auto_close_end_ms) return;
    let remaining = Math.max(0, (_auto_close_end_ms - Date.now()) / 1000);
    $(".ac-component-sealed-bid-auto-close-countdown").text('Auction closes in ' + _auto_close_most_significant_unit(remaining));
}

function _auto_close_most_significant_unit(seconds) {
    if (seconds <= 0) return '0 seconds';
    let days = Math.floor(seconds / 86400);
    if (days > 0) return days + (days === 1 ? ' day' : ' days');
    let hours = Math.floor(seconds / 3600);
    if (hours > 0) return hours + (hours === 1 ? ' hour' : ' hours');
    let minutes = Math.floor(seconds / 60);
    if (minutes > 0) return minutes + (minutes === 1 ? ' minute' : ' minutes');
    let secs = Math.floor(seconds);
    return secs + (secs === 1 ? ' second' : ' seconds');
}

async function _auto_close_update() {
    let $el = $(".ac-component-sealed-bid-auto-close-countdown");
    let auction = _.ac_state.auction;

    if (!auction.auto_close_enabled || !auction.date_end_universalized) {
        $el.hide();
        _auto_close_end_ms = null;
        if (_auto_close_interval) { clearInterval(_auto_close_interval); _auto_close_interval = null; }
        return;
    }

    let rounds = await auction.auction_rounds.fetch();
    let has_active = (rounds || []).some(r => r.status == App_Models_AuctionRound.STATUS_ACTIVE);
    if (!has_active) {
        $el.hide();
        _auto_close_end_ms = null;
        if (_auto_close_interval) { clearInterval(_auto_close_interval); _auto_close_interval = null; }
        return;
    }

    let utcStr = auction.date_end_universalized.replace(' UTC', '').replace(' ', 'T') + 'Z';
    _auto_close_end_ms = new Date(utcStr).getTime();

    _auto_close_tick();
    $el.show();

    if (!_auto_close_interval) {
        _auto_close_interval = setInterval(_auto_close_tick, 1000);
    }
}

_.AuctionUI_Sealed_Bid = class AuctionUI_Sealed_Bid {
    static session_updated_handler() {
        _.AuctionUI_Sealed_Bid.refresh();
    }

    static init() {
        if (_.AuctionUI.auction_is_sealed_bid()) {
            $form_items_container = $(".ac-modal-sealed-bid-amounts-repeater");

            _.AuctionUI.on_update_auction_items(_.AuctionUI_Sealed_Bid.refresh);

            // Auto-close countdown -- subscribe to auction and round updates
            _.AuctionUI_Data.on_data_update("auction", function () { _auto_close_update(); });
            _.AuctionUI_Data.on_data_update("auction.auction_rounds", function () { _auto_close_update(); });
            _auto_close_update();

            _.on_ui_update_once(".ac-btn-sealedbid", function () {
                $(this).click(function () {
                    _.AuctionUI_Bids.do_custom_bid();
                });
            });

            $(".ac-component-sealed-bid-pricing-values").append($(".bidding-sold-area").html());
            $(".ac-component-sealed-bid-pricing-values").append($(".bidding-prices-area-your-bid").html());
        }
    }

    static async refresh() {
        if (!_.AuctionUI.auction_is_sealed_bid()) {
            return;
        }

        let $header_line = $(".ac-component-sealed-bid-header-line");

        $header_line.show().text('One Chance Sealed Bid Auction');

        await _.mutex("_update_bidding_ui", async function () {
            $(".ac-btn-custombid").remove();
            $(".ac-component-bid").hide();
            $(".btn-view-bid-history").remove();

            let current_item = await _.AuctionUI.get_current_item();
            let current_round = await _.AuctionUI.get_current_round();

            $(".ac-component-bid").hide();
            $(".ac-component-sealed-bid").hide();
            $(".ac-component-sealed-bid-notice-you-have-bid-but-not-on-this-one").hide();
            $(".sealedbidding-place-bid-area").hide();
            $(".ac-component-sealed-bid-pricing-bidding-sold-area").hide();
            $(".ac-component-sealed-bid-pricing-values-your-bid").hide();
            $(".ac-component-sealed-bid-notice-no-sale").hide();
            $(".ac-component-sealed-bid-notice-winner-notice").hide();
            $(".ac-component-sealed-bid-notice-loser-notice").hide();
            $(".ac-component-sealed-bid-notice-you-have-bid-on-this-one").hide();
            $(".bidding-place-bid-area").remove();
            $(".btn-show-auction-summary").remove();
            $(".ac-btn-sealedbid-nobids").show();
            $(".ac-component-sealed-bid-notice-no-bid").show();
            $(".ac-component-sealed-bid-notice-contract-pending").hide();

            let $yourbid = $(".ac-component-sealed-bid-pricing-values-yourbid");

            let should_show_bid_area = false;
            let should_show_standard_sales_area = true;

            if (current_round) {

                // let users_bid_for_this_item = await _.Lib_Auction_Bids.best_bid_by_user(current_round);

                $(".ac-component-sealed-bid").show();

                if (current_round.status == App_Models_AuctionRound.STATUS_ACTIVE) {
                    should_show_bid_area = true;
                }

                let users_bid = null;

                if (_.ac_state.registrant) {
                    current_round = await current_round.private();

                    if (await _.AuctionUI_Sealed_Bid.user_has_placed_bids()) {
                        should_show_bid_area = false;
                        $(".ac-component-round-pending").remove();

                        users_bid = await _.Lib_Auction_Bids.best_bid_by_user(current_round);

                        if (users_bid && current_item) {

                            $header_line.hide();

                            $yourbid.text(_.currency(users_bid.amount));
                            $yourbid.css('color', 'black');

                            if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                                $(".ac-component-sealed-bid-pricing-values-peracre-total").show().html(
                                    await _.AuctionUI.fees_string_v2_multi_line_acres(users_bid.amount, current_item.acres)
                                );
                            } else {
                                $(".ac-component-sealed-bid-pricing-values-peracre-total").show().html(
                                    await _.AuctionUI.fees_string_v2_multi_line_flat(users_bid.amount)
                                );
                            }

                            if (current_round.status == App_Models_AuctionRound.STATUS_ACTIVE) {
                                $(".ac-component-sealed-bid-pricing-values-your-bid").show();
                                $(".ac-component-sealed-bid-notice-you-have-bid-on-this-one").show();
                            }

                        } else {
                            $(".ac-component-sealed-bid-notice-you-have-bid-but-not-on-this-one").show();
                        }
                    }
                }

                if (current_round.status == App_Models_AuctionRound.STATUS_NO_SALE) {
                    $(".ac-component-sealed-bid-notice-no-sale").show();
                    $(".ac-component-sealed-bid-notice-you-have-bid-but-not-on-this-one").hide();

                    // Show relisted link if tract was converted to a new auction
                    if (current_item.converted_to_auction_url) {
                        $(".ac-component-sealed-bid-notice-no-sale-text").hide();
                        $(".ac-component-sealed-bid-notice-no-sale-relisted-link").attr('href', current_item.converted_to_auction_url);
                        $(".ac-component-sealed-bid-notice-no-sale-relisted").show();
                    } else {
                        $(".ac-component-sealed-bid-notice-no-sale-text").show();
                        $(".ac-component-sealed-bid-notice-no-sale-relisted").hide();
                    }
                }

                if (current_round.status == App_Models_AuctionRound.STATUS_SOLD) {
                    $(".ac-component-sealed-bid-pricing-bidding-sold-hide").show();

                    if (_.ac_state.auction.auction_status == App_Models_Auction.STATUS_CONTRACT) {
                        $(".ac-component-sealed-bid-notice-contract-pending").show();
                        if (await _.AuctionUI_Sealed_Bid.user_has_placed_bids()) {
                            users_bid = await _.Lib_Auction_Bids.best_bid_by_user(current_round);
                            if (users_bid) {
                                $(".ac-component-sealed-bid-notice-you-have-bid-on-this-one").show();
                            } else {
                                $(".ac-component-sealed-bid-notice-you-have-bid-but-not-on-this-one").show();
                            }
                        }

                    } else {

                        let current_bid = await current_round.current_bid.fetch();

                        console.log(current_bid);

                        if (current_bid) {
                            $(".ac-component-sealed-bid-pricing-bidding-sold-area").show();

                            // Show "Winning Bid" if user placed a bid - we will show the bids side by side
                            if (users_bid) {
                                $(".ac-component-sealed-bid-pricing-bidding-sold-area-sale-text").text("Winning Bid:");
                            } else {
                                $(".ac-component-sealed-bid-pricing-bidding-sold-area-sale-text").text("Sale Price:");
                            }

                            // Make users bid red or green based on if they won
                            if (users_bid) {
                                if (current_bid.id == users_bid.id) {
                                    $yourbid.css('color', 'darkgreen');
                                    $(".ac-component-sealed-bid-notice-winner-notice").show();
                                } else {
                                    $yourbid.css('color', 'darkred');
                                    $(".ac-component-sealed-bid-notice-loser-notice").show();
                                }
                            }

                            // Render the winning bid prices
                            if (users_bid && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                                // Show it per acre if user placed a bid
                                $(".ac-component-sealed-bid-pricing-sale-price").text(_.currency(current_bid.amount));
                                $(".ac-component-sealed-bid-pricing-sale-price-extra").show().html(
                                    await _.AuctionUI.fees_string_v2_multi_line_acres(current_bid.amount, current_item.acres)
                                );
                            } else if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                                // Show full price if not
                                $(".ac-component-sealed-bid-pricing-sale-price").text(_.currency(current_bid.amount * current_item.acres));
                                $(".ac-component-sealed-bid-pricing-sale-price-extra").show().html(
                                    await _.AuctionUI.fees_string_v2_multi_line_acres(current_bid.amount, current_item.acres)
                                );
                            } else {
                                $(".ac-component-sealed-bid-pricing-sale-price").text(_.currency(current_bid.amount));
                                $(".ac-component-sealed-bid-pricing-sale-price-extra").show().html(
                                    await _.AuctionUI.fees_string_v2_multi_line_flat(current_bid.amount)
                                );
                            }
                        }
                    }

                }

            }

            if (should_show_bid_area) {
                $(".sealedbidding-place-bid-area").show();
            }
        });
    }

    static async user_has_placed_bids() {
        let items = await _.ac_state.auction.auction_items.fetch();
        for (let item of items) {
            let round = await item.auction_round.fetch();
            if (round) {
                if (await _.Lib_Auction_Bids.best_bid_by_user(round)) {
                    return true;
                }
            }
        }
        return false;
    }

    static async place_bids_button_handler() {

        let current_round_pub = await _.AuctionUI.get_current_round();
        if (!current_round_pub) {
            return;
        }

        let current_round = await current_round_pub.private();

        if (!(await _.Lib_Auction_Bids.can_bid(current_round))) {
            _.Modal.alert("You may not bid at this time.");
            return;
        }

        if (!(await _.AuctionUI_Sealed_Bid.user_has_placed_bids())) {
            _.AuctionUI_Sealed_Bid.sealed_bid_modal();
        } else {
            // Todo: custom modal showing user submissions
            _.Modal.alert(
                "You have already placed your bids for this auction.\n\n" +
                "If you have any questions, please contact the auction manager."
            );
        }
    }

    static async sealed_bid_modal(item_id = null) {
        step_number = 1;

        $modal = $("#ac-modal-sealed-bid-modal");

        // Verify user agreed to TOC
        if (! await _.AuctionUI_Auction_Registration.validate_toc_is_current(true)) {
            return;
        }

        // Setup event handlers
        if (!sealed_bid_modal_ui_init) {
            sealed_bid_modal_ui_init = true;

            $("#ac-modal-sealed-bid-terms-file-upload-input").droppable();

            $(".ac-modal-sealed-bid-step1-next").on('click', _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_next);
            $(".ac-modal-sealed-bid-step2-goback").on('click', _.AuctionUI_Sealed_Bid.sealed_bid_modal_step2_ui_goback);
            $(".ac-modal-sealed-bid-btn-submit").on('click', _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_submit);

        }

        $("#ac-modal-sealed-bid-terms-file-upload-input").droppable_reset();

        // Clear existing UI elements
        $form_items_container.empty();

        // Load items
        property = await _.ac_state.auction.property.fetch();
        items_all = await _.ac_state.auction.auction_items.fetch();

        items_active = [];
        item_ids = [];

        for (let item of items_all) {
            let round = await (item.auction_round.fetch());
            if (round && round.status == App_Models_AuctionRound.STATUS_ACTIVE) {
                items_active.push(item);
                item_ids.push(item.id);
            }
        }

        // Set step 1 view
        $(".ac-modal-sealed-bid-step1-errors").hide();
        $(".ac-modal-sealed-bid-step1").show();
        $(".ac-modal-sealed-bid-step2").hide();

        // Populate some components
        $(".ac-modal-sealed-bid-auctionname-header").text(property.title);
        $(".ac-modal-sealed-bid-terms-agreement").html(_.ac_state.auction.sealed_bid_final_agreement_text);

        // Initialize / Redraw dynamic components
        await _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_refresh();

        await _.AuctionUI_Sealed_Bid.__sealed_bid_modal_show();
    }

    static async __sealed_bid_modal_show() {
        $modal.modal_show();

        _.set_poised_modal(true);

        await _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_refresh();
    }

    // Initialize / Redraw dynamic components
    static async sealed_bid_modal_ui_refresh() {

        await _.mutex("_sealed_bid_modal_ui_refresh", async function () {

            // Determine if there are any 'per acre' items, ui looks different on every item if true
            let has_per_acre_item_in_auction = false;

            for (let item of items_active) {
                if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                    has_per_acre_item_in_auction = true;
                }
            }

            // Running grand total of amounts
            let grand_total = 0;

            // Render individual items
            for (let item of items_active) {
                let $component = $form_items_container.component(item.id, 'default', { sort_id: item.order });
                let $amount_input = $component.find(".ac-modal-sealed-bid-amount-input");

                // Initializers
                if (!$component.data('_has_init')) {
                    // Run once per component
                    $component.data('_has_init', true);

                    // Currency input effects
                    $amount_input.currencyInput();

                    $amount_input.on('keyup', _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_refresh);
                    $amount_input.on('change', _.AuctionUI_Sealed_Bid.sealed_bid_modal_ui_refresh);

                    // On click item area, click the input area
                    $component.click(function (event) {
                        if (event.target !== $amount_input[0] && !$amount_input.is(':focus')) {
                            $amount_input.focus().select();
                        }
                    });

                    if (has_per_acre_item_in_auction) {
                        $component.css('text-align', 'left');
                    } else {
                        $component.css('text-align', 'center');
                    }
                }

                // Get component value
                let amount = $amount_input.val();

                if (isNaN(amount)) {
                    amount = 0;
                }

                // Draw component
                $component.find('.ac-modal-sealed-bid-amounts-item-title-tract').text(item.title);

                let totalstr = "";

                if (item.acres) {
                    $component.find('.ac-modal-sealed-bid-amounts-item-title-name').text(" - " + item.acres + " " + _.property_noun_unit_plural_ucwords_plusminus() + " in " + property.county + ", " + property.state);
                } else {
                    $component.find('.ac-modal-sealed-bid-amounts-item-title-name').text("in " + property.county + ", " + property.state);
                }

                if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                    $component.find('.ac-modal-sealed-bid-amount-total-text').html(" per " + _.property_noun_unit_singular() + " X " + item.acres + " " + _.property_noun_unit_abbr_plusminus() + " " + (amount > 0 ? "=" : ""));
                    if (amount > 0) {
                        totalstr = _.currency(amount * item.acres);
                        grand_total += (amount * item.acres);
                    }
                } else {
                    $component.find('.ac-modal-sealed-bid-amount-total-text').text(" flat price " + ((has_per_acre_item_in_auction && amount > 0) ? "=" : ""));
                    if (amount > 0) {
                        totalstr = _.currency(amount);
                        grand_total += amount;
                    }
                }

                // Show total line only if per acre items
                if (has_per_acre_item_in_auction && totalstr != "") {
                    $component.find(".ac-modal-sealed-bid-item-total-line").show().text(totalstr);
                } else {
                    $component.find(".ac-modal-sealed-bid-item-total-line").hide();
                }

                // Highlight component with values
                if (amount > 0) {
                    $component.addClass('ac-modal-sealed-bid-amounts-item-enabled');
                } else {
                    $component.removeClass('ac-modal-sealed-bid-amounts-item-enabled');
                }
            }

            // Render grand total
            let $grand_total = $(".ac-modal-sealed-bid-combined-total-line")
            if (grand_total > 0) {
                if (_.ac_state.auction.total_fees > 0) {
                    $grand_total.html("<strong>Total:</strong> " + (await _.AuctionUI.fees_string_v2_single_line_flat(grand_total)));
                } else {
                    $grand_total.html("<strong>Total:</strong> <strong>" + _.currency(grand_total) + "</strong>");
                }
                if (has_per_acre_item_in_auction && step_number == 1) {
                    $grand_total.css('text-align', 'right');
                } else {
                    $grand_total.css('text-align', 'center');
                }
            } else {
                $grand_total.html("&nbsp;");
            }

            $form_items_container.remove_unlisted_components(item_ids);
        });
    }

    // The next button was clicked on page 1 of the form.
    static async sealed_bid_modal_ui_next() {
        $(".ac-modal-sealed-bid-step1-errors").hide();

        // Serialize the users selections.
        serialized_bids = [];

        for (let item of items_active) {
            let $component = $form_items_container.component(item.id, 'default', { sort_id: item.order });
            let $amount_input = $component.find(".ac-modal-sealed-bid-amount-input");
            let amount = $amount_input.val();
            if (amount > 0) {
                serialized_bids.push({ id: item.id, amount: amount });
            }
        }

        if (serialized_bids.length == 0) {
            $(".ac-modal-sealed-bid-step1-errors").text("You must enter at least one bid to continue").show();
            return;
        }

        // Handle file upload
        _.Modal.hide();

        let $uploader = $("#ac-modal-sealed-bid-terms-file-upload-input");

        upload_key = null;
        file_name = null;

        if (!$uploader.droppable_file_is_dropped()) {
            if (!(await _.Modal.confirm("You did not provide a lender / proof of funds document.\n\nContinue anyway?\n\n"))) {
                _.AuctionUI_Sealed_Bid.sealed_bid_modal_step2_ui_goback();
                return;
            }
        }

        if ($uploader.droppable_file_is_dropped()) {
            if ($uploader.droppable_file_is_uploading()) {
                _.Modal.unclosable("Please wait while the file uploads...");
                upload_key = await $uploader.droppable_upload_get_response();
                _.Modal.hide();
            } else {
                upload_key = await $uploader.droppable_upload_get_response();
                file_name = $uploader.droppable_get_filename();
            }

            if (typeof (upload_key) != 'string' || upload_key.error) {
                await _.Modal.alert("There was an issue uploading your file.\n\nPlease try to upload the file again.");
                _.AuctionUI_Sealed_Bid.sealed_bid_modal_step2_ui_goback();
                return;
            }
        }

        // Pass, change to step 2
        $(".ac-modal-sealed-bid-step1").hide();
        step_number = 2;
        await _.sleep(500);

        // Repopulate form with new values
        let $confirm_repeater = $(".ac-modal-sealed-bid-amounts-confirm-repeater");
        $confirm_repeater.empty();

        for (let item of items_active) {

            let titletext = item.title;

            if (item.acres) {
                titletext += " - " + item.acres + " " + _.property_noun_unit_plural_ucwords_plusminus() + " in " + property.county + ", " + property.state;
            } else {
                titletext += " in " + property.county + ", " + property.state;
            }

            let $component = $confirm_repeater.component(item.id, 'default', { sort_id: item.order });

            $component.find(".ac-modal-sealed-bid-amounts-item-confirm-title").text(titletext);

            let found = false;

            for (let temp_bid of serialized_bids) {
                if (item.id == temp_bid.id) {

                    found = true;

                    let amounthtml = "";

                    if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                        amounthtml = await _.AuctionUI.fees_string_v2_single_line_acres(temp_bid.amount, item.acres);
                    } else {
                        amounthtml = await _.AuctionUI.fees_string_v2_single_line_flat(temp_bid.amount);
                    }

                    $component.find(".ac-modal-sealed-bid-amounts-item-confirm-amount").html(amounthtml);
                    $component.css('background-color', 'auto');
                    $component.addClass('ac-modal-sealed-bid-amounts-item-enabled');
                }
            }

            if (!found) {
                $component.find(".ac-modal-sealed-bid-amounts-item-confirm-amount").html(
                    "<i style='color:#333; font-weight: bold;'>(No Bid)</i>"
                );
                $component.css('background-color', '#eee');
                $component.removeClass('ac-modal-sealed-bid-amounts-item-enabled');
            }
        }

        let $file_upload_result = $(".ac-modal-sealed-bid-combined-file-upload-result").hide();
        let $file_upload_none = $(".ac-modal-sealed-bid-combined-file-upload-none").hide();

        if (upload_key) {
            $file_upload_result.show();
            $file_upload_result.html("Proof of Funds Document:&nbsp;&nbsp;&nbsp;<i class='fa-solid fa-file'></i>&nbsp;<span class='pofd_fn' style='font-weight: bold;'></span>");
            $file_upload_result.find('.pofd_fn').text(file_name);
        } else {
            $file_upload_none.show();
        }

        // Show next form
        $(".ac-modal-sealed-bid-step2").show();
        _.AuctionUI_Sealed_Bid.__sealed_bid_modal_show();
        $(".ac-modal-sealed-bid-step2-errors").hide();
    }

    static async sealed_bid_modal_step2_ui_goback() {
        _.Modal.hide();
        $(".ac-modal-sealed-bid-step2").hide();
        await _.sleep(500);
        $(".ac-modal-sealed-bid-step1").show();
        _.AuctionUI_Sealed_Bid.__sealed_bid_modal_show();
    }

    // The submit button was clicked on page 2 of the form.
    static async sealed_bid_modal_ui_submit() {
        $(".ac-modal-sealed-bid-step2-errors").hide();

        let signature = $(".ac-modal-sealed-bid-sign").val().trim();

        if (signature.length < 2) {
            $(".ac-modal-sealed-bid-step2-errors").text("You must enter your name in the signature area to continue.").show();
            return;
        }

        let submission_data = {
            auction_id: _.ac_state.auction.id,
            bids: serialized_bids,
            upload_key: upload_key,
            agreed_terms: $(".ac-modal-sealed-bid-terms-agreement").text(),
            signature: signature
        }

        try {
            _.Modal.hide();
            _.Modal.unclosable("Please Wait", "Submitting One Chance Sealed Bid Form...");

            // Todo: file upload

            await _.backend_ajax('auctions', 'sealed_bid_submit', submission_data);
            await _.data_sync();

            _.Modal.hide();
            _.Modal.alert(
                "Success",
                "Your bids have been submitted!"
            );

            // Server now sends notification that registration is received and pending approval

        } catch (error) {
            _.Modal.hide();

            $(".ac-modal-sealed-bid-step2").show();

            _.AuctionUI_Sealed_Bid.__sealed_bid_modal_show();

            if (typeof (error) != "string") {
                error = "Unexpected error occured communicating with AuctionCast API. Please try again, or contact AuctionCast support if the issue continues.";
            }

            $(".ac-modal-sealed-bid-step2-errors").text(error).show();
        }
    }
}